import ReactDOM from "react-dom";
import React from "react";

import App from "./App";
import AppAufkleber from "./AppAufkleber";
import AppAufkleberNeu from "./AppAufkleberNeu";
import AppSVG from "./AppSVG";
import AppSVG2 from "./AppSVG2";
import AppKlebeschriftenKonfiguratorNeu from "./AppKlebeschriftenKonfiguratorNeu";

const rootEl = document.getElementById("react-cart-tool-tip");

console.log("yes");

const el = window.location.href.includes("kopie-von-aufkleber-konfigurator-fuer-svgs") ? (
  <AppSVG2 />
) : window.location.href.includes("aufkleber-konfigurator-fuer-svg") ? (
  <AppSVG />
) :window.location.href.includes("copy-of-aufkleber-konfigurator") ? (
  <AppAufkleber />
) : window.location.href.includes("aufkleber-konfigurator") ? (
  <AppAufkleberNeu />
) : window.location.href.includes("klebeschriften-erstellen") ? (
  <AppKlebeschriftenKonfiguratorNeu />
) : window.location.href.includes(
    "klebeschriften-klebebuchstaben-konfigurator"
  ) ? (
  <App />
) : null;

ReactDOM.render(el, rootEl);
